import { Box, HStack } from '@chakra-ui/react'

interface ENPSProps {
  questao?: iRespostaQuestao
}

interface iRespostaQuestao {
  enunciado: string
  tipo: number
  alternativaResposta: string[]
}

export function ENPS({ questao }: ENPSProps): JSX.Element {
  return (
    <HStack spacing={2} wrap="wrap">
      {Array.from({ length: 11 }, (_, i) => {
        const checked = questao?.alternativaResposta.includes(i.toString())

        return (
          <Box
            key={i}
            w="36px"
            h="36px"
            borderRadius="full"
            borderWidth="2px"
            border="solid"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontWeight="600"
            bg={checked ? 'blue.500' : 'transparent'}
            color={checked ? 'white' : 'inherit'}
            borderColor={checked ? 'blue.500' : 'gray.300'}
          >
            {i}
          </Box>
        )
      })}
    </HStack>
  )
}
